/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskInJobDto } from './TaskInJobDto';
import {
    TaskInJobDtoFromJSON,
    TaskInJobDtoFromJSONTyped,
    TaskInJobDtoToJSON,
} from './TaskInJobDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfTaskInJobDto
 */
export interface ODataPostProcessedResultsOfTaskInJobDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTaskInJobDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TaskInJobDto>}
     * @memberof ODataPostProcessedResultsOfTaskInJobDto
     */
    value?: Array<TaskInJobDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfTaskInJobDto
     */
    $type?: ODataPostProcessedResultsOfTaskInJobDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTaskInJobDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfTaskInJobDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoTaskInJobDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.TaskInJobDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfTaskInJobDtoTypeEnum = typeof ODataPostProcessedResultsOfTaskInJobDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfTaskInJobDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfTaskInJobDto interface.
 */
export function instanceOfODataPostProcessedResultsOfTaskInJobDto(value?: unknown): value is ODataPostProcessedResultsOfTaskInJobDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfTaskInJobDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfTaskInJobDtoFromJSON(json: any): ODataPostProcessedResultsOfTaskInJobDto {
    return ODataPostProcessedResultsOfTaskInJobDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfTaskInJobDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfTaskInJobDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(TaskInJobDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfTaskInJobDtoToJSON(value?: ODataPostProcessedResultsOfTaskInJobDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(TaskInJobDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

